import { call } from 'redux-saga/effects';

import { ServerFilterClauses } from '~commonInfra/utils/ServerFilterClauses';
import { Messages } from '~src/codegen/Localize';
import { imgPath } from '~src/commonInfra/utils/ImgUrl';
import { SimulationCard } from '~src/simulation/components/cardView/SimulationCard';
import { Simulations } from '~src/simulation/resources/Simulations';
import { SpacesSiteUrls } from '~src/spacesPlatform/components/spaceComponents/SpacesSiteUrls';
import { ContentTypeFilterClause,MixedContentItemDefinition, SpaceDefinition } from '~src/spacesPlatform/contentDefinitionInterfaces/ContentDefinitionsTypes';
import { SimulationContentType } from '~src/spacesPlatform/models/ContentTypes';
import { IContentInfo } from '~src/spacesPlatform/models/IContentInfo';
import { getSimulationInfos } from '~src/spacesPlatform/sagas/SpacesSagaHelpers';

import { getGenericDefaultFilters } from '../../spacesPlatform/contentDefinitions/getDefaultFilters';

export const SimulationDefinition: MixedContentItemDefinition & SpaceDefinition<'simulation'> = {
  itemType: 'simulation',
  contentType: 'simulation',
  singularName: Messages.simulation,
  pluralName: Messages.simulations,
  emptyStateMessage: Messages.simulationsEmptyMessage,
  siteFilterByTypeDropdownName: Messages.siteFilterByTypeDropdown_Simulations,
  contentFilterKeys: SimulationContentType.filterKeys,
  defaultFilters: getGenericDefaultFilters,
  cardComponent: SimulationCard,
  listViewIconUrl: imgPath('simulation_18px-large.svg'),
  filterClause: ServerFilterClauses.ContentType(['simulation']) as ContentTypeFilterClause,
  contentSpaceUrl: (urls: SpacesSiteUrls, contentId: string) => urls.simulationUrl(contentId),
  getBasicQuery: () => {
    return Simulations.all().withExtraParams(SimulationContentType.extraQueryParams);
  },
  fieldValueResourceType: 'simulation',
  getContentInfo: (contentList: IContentInfo[]) => call(getSimulationInfos, contentList),
  supportedDisplayModes: ['list', 'thumbnail'],
  headerIconPath: (contentInfo) => Simulations.getSimulationIconPath(contentInfo),
};
